import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

const frontPage = {
    readyFn: function () {
        let self = this;
        self.initSliders();
        self.forYouSwiperInit();
    },

    initSliders: function() {
        this.introSwiperInit();
        this.intrMobileSwiperInit();
        
        // Mettre à jour Locomotive Scroll après l'initialisation des sliders
        setTimeout(() => {
            if (window.locomotiveScroll) {
                window.locomotiveScroll.update();
            }
        }, 500);
    },

    introSwiperInit: function () {
        const introSwiperInit = new Swiper('#intro .swiper', {
            modules: [Navigation, Pagination, Autoplay],
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            pagination: {
                el: '#intro .swiper-pagination'
            },
            navigation: {
                nextEl: '#intro .swiper-button-next',
                prevEl: '#intro .swiper-button-prev',
            },
            on: {
                init: function() {
                    // Animer le premier slide au chargement
                    setTimeout(() => {
                        frontPage.animateSlide(0);
                    }, 500);
                },
                slideChange: function() {
                    // Réinitialiser toutes les animations
                    frontPage.resetAllSlides();
                    // Animer le nouveau slide actif
                    setTimeout(() => {
                        frontPage.animateSlide(this.activeIndex);
                    }, 100);
                }
            }
        });
    },

    intrMobileSwiperInit: function() {
        const introMobileSwiper = new Swiper('#intro-mobile .swiper', {
            modules: [Navigation, Pagination, Autoplay],
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            pagination: {
                el: '#intro-mobile .swiper-pagination'
            },
            navigation: {
                nextEl: '#intro-mobile .swiper-button-next',
                prevEl: '#intro-mobile .swiper-button-prev',
            }
        });
    },

    animateSlide: function(index) {
        const slide = document.querySelector(`.intro .swiper-slide:nth-child(${index + 1})`);
        if (slide) {
            const textElement = slide.querySelector('.slide-text');
            const imageElement = slide.querySelector('.slide-image');
            
            if (textElement) {
                textElement.classList.remove('opacity-0', '-translate-x-8');
                textElement.classList.add('opacity-100', 'translate-x-0');
            }
            
            if (imageElement) {
                imageElement.classList.remove('opacity-0', 'translate-x-8');
                imageElement.classList.add('opacity-100', 'translate-x-0');
            }
        }
    },

    resetAllSlides: function() {
        document.querySelectorAll('.intro .slide-text').forEach(el => {
            el.classList.remove('opacity-100', 'translate-x-0');
            el.classList.add('opacity-0', '-translate-x-8');
        });
        
        document.querySelectorAll('.intro .slide-image').forEach(el => {
            el.classList.remove('opacity-100', 'translate-x-0');
            el.classList.add('opacity-0', 'translate-x-8');
        });
    },

    forYouSwiperInit: function () {
        const forYouSwiper = new Swiper('section#for-you .swiper', {
            modules: [Navigation, Pagination],
            slidesPerView: 1.4,
            spaceBetween: 20,
            loop: true,
            // navigation: {
            //     nextEl: 'section#for-you .swiper-button-next',
            //     prevEl: 'section#for-you .swiper-button-prev',
            // },
            // pagination: {
            //     el: 'section#for-you .swiper-pagination',
            //     clickable: true,
            // },
        });
    }

};

export { frontPage };